<template>
  <div class="unqualified-page">
    <div class="df df-center" style="margin-bottom: 20px">
      <!-- <a-select
        v-model:value="requestPayload.modelSpecifications"
        :options="modelSpecificationsOption"
        placeholder="选择项目"
        @change="handleSearch"
        style="width: 120px; margin-right: 20px"
        allowClear
      ></a-select> -->

      <a-select
        v-model:value="requestPayload.year"
        :options="yearOption"
        placeholder="请选择年度"
        @change="handleSearch"
        allowClear
        style="width: 120px"
      >
      </a-select>
    </div>

    <div class="df df-center" style="margin-bottom: 20px">
      <unqualified-year
        :unQualifiedData="unQualifiedSummary"
        :year="requestPayload.year"
      ></unqualified-year>
    </div>

    <div>
      <rate-qoq :unQualifiedQOQ="unQualifiedQOQ" :year="requestPayload.year">
      </rate-qoq>
    </div>

    <div>
      <unqualified-month
        :year="requestPayload.year"
        :unQualifiedData="unQualifiedSummary"
      ></unqualified-month>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, inject, ref, watch, provide } from "vue";
import {
  modelSpecificationsOption,
  PQCProductOption,
} from "@/views/productDaily/serve/option";

import { useYearOption } from "@/views/productDaily/components/quality/PassRate/serve/option";

import {
  summaryOfUnqualifiedRateData,
  summaryOfUnqualifiedRateQOQData,
} from "@/request/view/productionInstruction";

import unqualifiedYear from "@/views/productDaily/components/quality/unqualified/unQualifiedSummary/year.vue";
import rateQoq from "@/views/productDaily/components/quality/unqualified/unQualifiedSummary/rateQOQ.vue";
import unqualifiedDetailsByMonth from "@/views/productDaily/components/quality/unqualified/unQualifiedSummary/detailsByMonth.vue";
import unqualifiedMonth from "@/views/productDaily/components/quality/unqualified/unQualifiedSummary/month.vue";
import { useRoute } from "vue-router";

export default defineComponent({
  components: {
    unqualifiedYear,
    unqualifiedMonth,
    rateQoq,
    unqualifiedDetailsByMonth,
  },
  setup() {
    const { currentYear, yearOption } = useYearOption();
    const route = useRoute();
    const requestPayload = reactive({
      modelSpecifications: "swan",
      produceOrTpc: route.meta.produceOrTpc,
      year: currentYear,
    });

    const PQCkeyList = reactive([]);
    provide("PQCkeyList", PQCkeyList);
    const initPQCkeyList = () => {
      PQCkeyList.length = 0;
      PQCProductOption.filter((f) => f.label !== "包装").forEach((item) => {
        PQCkeyList.push(item.value);
      });
      PQCkeyList.push("合计");
    };

    // 不合格率汇总
    const unQualifiedSummary = ref(null);

    // 不合格环比汇总
    const unQualifiedQOQ = ref(null);

    const getunQualidiedQOQ = () => {
      unQualifiedQOQ.value = null;
      summaryOfUnqualifiedRateQOQData(requestPayload).then((res) => {
        if (
          res.code === 200 &&
          res.message === "成功" &&
          res.data &&
          Object.keys(res.data).length > 0
        ) {
          unQualifiedQOQ.value = res.data;
        }
      });
    };

    const getUnQualifiedSummary = () => {
      unQualifiedSummary.value = null;
      summaryOfUnqualifiedRateData(requestPayload).then((res) => {
        if (
          res.code === 200 &&
          res.message === "成功" &&
          res.data &&
          Object.keys(res.data).length > 0
        ) {
          unQualifiedSummary.value = res.data;
        }
      });
    };

    const handleSearch = () => {
      getUnQualifiedSummary();
      getunQualidiedQOQ();
    };

    const init = () => {
      requestPayload.year = currentYear;
      initPQCkeyList();
      getUnQualifiedSummary();
      getunQualidiedQOQ();
    };

    const tabActivekey = inject("subUnqualifiedKey", null);
    watch(
      () => tabActivekey,
      (val) => {
        if (val && val.value && val.value === "summaryOfunqualified") {
          init();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      unQualifiedQOQ,
      handleSearch,
      yearOption,
      unQualifiedSummary,
      requestPayload,
      modelSpecificationsOption,
    };
  },
});
</script>

<style lang="less" scoped>
.unqualified-page {
  height: calc(100vh - 260px);
  overflow-y: scroll;
}
:deep(.statistics) {
  text-align: center;
  font-weight: bold;
}

:deep(.rate-table-layout) {
  flex-flow: wrap;
}

:deep(.rate-table) {
  // margin-right: 10px;
  td {
    width: 60px;
    height: 32px;
    text-align: center;
    line-height: 32px;
  }
  .process {
    width: 120px;
  }
  .project {
    height: 94px;
  }
}
</style>
